{
  "header": "Сведения об активе",
  "subtitle": "Актив, прикреплённый к вашему грузовику (прицеп, контейнер и т. д.).",
  "assetType": "Тип актива",
  "assetTypePlaceholder": "Выберите тип актива",
  "assetId": "ID актива (например, номер прицепа)",
  "assetIdPlaceholder": "Напр.: номер прицепа, ID контейнера и т. д.",
  "remove": "Удалить",
  "addAnother": "Добавить ещё актив",
  "trailerType": "Тип прицепа",
  "trailerId": "ID прицепа"
}
